(function() {
    const initVideoTextSection = function() {
      const collapsibles = document.querySelectorAll('.video-text-collapsible');
      
      collapsibles.forEach(collapsible => {
        const trigger = collapsible.querySelector('.video-text-collapsible-trigger');
        const content = collapsible.querySelector('.video-text-collapsible-content');
        content.style.height = '0px';
        
        trigger.addEventListener('click', () => {
          const isActive = collapsible.classList.contains('active');
          collapsibles.forEach(otherCollapsible => {
            if (otherCollapsible !== collapsible && otherCollapsible.classList.contains('active')) {
              otherCollapsible.classList.remove('active');
              otherCollapsible.querySelector('.video-text-collapsible-content').style.height = '0px';
            }
          });
          if (isActive) {
            collapsible.classList.remove('active');
            content.style.height = '0px';
          } else {
            collapsible.classList.add('active');
            content.style.height = content.scrollHeight + 'px';
          }
        });
      });
      const muteButtons = document.querySelectorAll('.video-unmute-btn');
      
      muteButtons.forEach(button => {
        const desktopVideoId = button.getAttribute('data-video-id');
        const mobileVideoId = button.getAttribute('data-mobile-video-id');
        const desktopVideo = document.getElementById(desktopVideoId);
        const mobileVideo = document.getElementById(mobileVideoId);
        const unmuteIcon = button.querySelector('.unmute-icon');
        const muteIcon = button.querySelector('.mute-icon');
        
        button.addEventListener('click', () => {
          const isMuted = desktopVideo ? desktopVideo.muted : true;
          
          if (isMuted) {
            // Unmute videos
            if (desktopVideo) desktopVideo.muted = false;
            if (mobileVideo) mobileVideo.muted = false;
            unmuteIcon.style.display = 'none';
            muteIcon.style.display = 'block';
          } else {
            // Mute videos
            if (desktopVideo) desktopVideo.muted = true;
            if (mobileVideo) mobileVideo.muted = true;
            unmuteIcon.style.display = 'block';
            muteIcon.style.display = 'none';
          }
        });
      });
      
   
    };
  
    // Run the initialization when the DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoTextSection);
    } else {
      initVideoTextSection();
    }
  })();